import { render, staticRenderFns } from "./FollowCompanyList.vue?vue&type=template&id=761706bf&scoped=true"
import script from "./FollowCompanyList.vue?vue&type=script&lang=js"
export * from "./FollowCompanyList.vue?vue&type=script&lang=js"
import style0 from "./FollowCompanyList.vue?vue&type=style&index=0&id=761706bf&prod&lang=scss&scoped=true"
import style1 from "./FollowCompanyList.vue?vue&type=style&index=1&id=761706bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761706bf",
  null
  
)

export default component.exports